import LoyaltyPointProductSelect from "./loyaltyPointProductSelect.container";

export default LoyaltyPointProductSelect;
